import { ChevronLeft, Download, Event, Groups2, MapsHomeWork, Receipt, Rule, Settings } from "@mui/icons-material";
import { ListSubheader, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlClient, GqlPermissions } from "~/__generated__";
import GaiaMenuItem from "~/modules/app/components/GaiaMenuItem";
import useHasTenantPermission from "~/modules/auth/hooks/useHasPermission";

import useCreateClientUrl from "../../hooks/useCreateClientUrl";

interface Props {
    client: GqlClient;
}

export default function ClientMenu({ client }: Props) {
    const { t } = useTranslation("client");
    const isAdmin = useHasTenantPermission(GqlPermissions.Administrator);
    const createClientUrl = useCreateClientUrl();

    return (
        <>
            <ListSubheader sx={{ backgroundColor: "background.default" }}>
                <Typography margin={1} variant="body2">
                    {client.name}
                </Typography>
            </ListSubheader>
            {isAdmin && <GaiaMenuItem to={"../admin/clients"} label={t("clientMenu.backToClients")} icon={<ChevronLeft />} />}

            <GaiaMenuItem
                to={createClientUrl("", { client })}
                label={t("clientMenu.projects")}
                icon={<MapsHomeWork />}
                matchExact
            />

            <GaiaMenuItem
                to={createClientUrl("protocols", { client })}
                label={t("clientMenu.protocolTemplates")}
                icon={<Rule />}
            />

            <GaiaMenuItem
                to={createClientUrl("planned", { client })}
                label={t("clientMenu.planned")}
                icon={<Event />}
                matchExact
            />

            <GaiaMenuItem to={createClientUrl("export", { client })} label={t("clientMenu.projectExport")} icon={<Download />} />

            {isAdmin && (
                <>
                    <GaiaMenuItem
                        to={createClientUrl("invoices", { client })}
                        label={t("clientMenu.invoices")}
                        icon={<Receipt />}
                    />

                    <GaiaMenuItem to={createClientUrl("users", { client })} label={t("clientMenu.users")} icon={<Groups2 />} />

                    <GaiaMenuItem
                        to={createClientUrl("settings", { client })}
                        label={t("clientMenu.settings")}
                        icon={<Settings />}
                    />
                </>
            )}
        </>
    );
}
